import React from 'react';

type Props = React.SVGAttributes<SVGElement>;

const SearchIcon = React.forwardRef<SVGSVGElement, Props>((props, ref) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props} ref={ref}>
    <path
      d="M13 13L19 19M8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15Z"
      stroke="#0F131A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));

SearchIcon.displayName = 'SearchIcon';

export default SearchIcon;
